"use client";

import { c as _c } from "react/compiler-runtime";
import { TabbedPosts } from "@/views/post/partials/TabbedPosts/TabbedPosts";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
import type { PostsVariant } from "@/views/post/partials/shared/types";
export type TabbedRelatedContentVariant = PostsVariant;
export interface TabbedRelatedContentProps {
  /** Visual variant of the article grids */
  variant?: TabbedRelatedContentVariant;
  /** Custom container className */
  className?: string;
  /** Default active tab */
  defaultTab?: "related" | "category";
  /** Force a fixed number of columns (1, 2, or 3). If not set, uses responsive defaults. */
  columns?: 1 | 2 | 3;
}

/**
 * TabbedRelatedContent - Displays a tabbed interface switching between
 * related articles and latest from category.
 * Thin wrapper over TabbedPosts that provides article-specific labels and links.
 */
export function TabbedRelatedContent(props) {
  const $ = _c(6);
  const labels = useLabels();
  const nav = useNavigation();
  let t0;
  if ($[0] !== labels.articlePage.latestFromCategory || $[1] !== labels.articlePage.latestNews || $[2] !== labels.articlePage.relatedArticles || $[3] !== nav.post || $[4] !== props) {
    t0 = <TabbedPosts {...props} buildLink={nav.post} relatedLabel={labels.articlePage.relatedArticles} categoryLabel={labels.articlePage.latestFromCategory} latestLabel={labels.articlePage.latestNews} />;
    $[0] = labels.articlePage.latestFromCategory;
    $[1] = labels.articlePage.latestNews;
    $[2] = labels.articlePage.relatedArticles;
    $[3] = nav.post;
    $[4] = props;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
}